module.exports = __webpack_public_path__ + "img/a012_1.76af0639.png";